<template>
  <section>
    <EnviarPermisoFuncionarioJefe />
    <EnviarPermiso />
    <EnviarPermisoRRHH />
    <AddSolicitud />
    <VerPermiso />
    <VerReporte />
    <ver-seguimiento />
    <AnularPermiso />
    <AprobarRRHHSinPermisos />
    <AprobarPermiso />
    <AprobarPermisoRRHH />
    <RechazarPermisoRRHH />
    <ReenviarPermiso/>
    <ModificarPermiso />
    <ModificarPermisoCompensacion />
    <ModificarPermisoToleranciaCompensacion />
    <EditarPermisoCargoVacacion />
    <compensar-permiso />
    <CompensarPermisoParticular />
    <CompensarPermisoTolerancia />
    <VerDocumento />

    <h3 class="primary--text">
      <v-icon info>exit_to_app</v-icon>{{ titulo_permiso }} de permisos,
      licencias, y omisiones
    </h3>
    <v-btn v-if="$route.params.id" icon color="primary" :to="`/permisos/rrhh`">
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <!-- Seleccionar gestion-->
    <v-flex xs12 md6>
      <v-autocomplete
        class="text-field-reducido-border"
        :items="lista_gestiones"
        item-text="periodo"
        item-value="periodo"
        label="Seleccione la gestión"
        v-model="periodo_seleccionado"
        @change="actualizaCrudTable()"
        required
        outline
        success
        clearable
      ></v-autocomplete>
    </v-flex>
    <h4 style="color: #000" v-if="!esUsuario">
      <b>NOMBRE COMPLETO:</b> <v-spacer></v-spacer> {{ nombres }}
    </h4>
    <v-card>
      <v-card-text>
        <crud-table
          class="tabla-comprimida-light tabla-permisos"
          v-if="sw_crud_table"
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :data-graphql="dataGraphql"
          :initData="initData"
          :widthModal="840"
        >
          <template slot="buttons">
            <v-tooltip bottom v-if="esUsuario">
              <v-btn color="primary" slot="activator" to="/permisos/crear/"
                ><v-icon>event_note</v-icon> Nueva Solicitud
              </v-btn>
              <span>Crear nuevo permiso</span>
            </v-tooltip>
          </template>

          <template slot="buttons" v-if="!esUsuario">
            <v-tooltip bottom>
              <v-btn
                color="primary"
                :to="`/permisos/crearRRHH/${getPersonaId()}`"
                slot="activator"
                ><v-icon>event_note</v-icon> Nueva Solicitud
              </v-btn>
              <span>Crear nuevo permiso</span>
            </v-tooltip>
          </template>

          <template slot="items" slot-scope="items">
            <td>{{ items.item.numero }}</td>
            <td>{{ items.item.fecha_emision }}</td>
            <td>{{ items.item.fecha_desde }}</td>
            <!--Fecha desde -->
            <td>{{ items.item.fecha_retorno }}</td>
            <td>{{ items.item.tipo_permiso }}</td>
            <td class="text-xs-center">
              {{
                items.item.horas_permiso == null
                  ? "00:00"
                  : $moment(items.item.horas_permiso, "HH:mm").format("HH:mm")
              }}
            </td>
            <td>
              {{
                items.item.id_tipo_permiso == 90 &&
                items.item.motivo !=
                  "OTROS(ENFERMEDAD COMUN,RIESGO PROFESIONAL, RIESGO EXTRAORDINARIO)"
                  ? items.item.motivo
                  : items.item.motivo ==
                      "OTROS(ENFERMEDAD COMUN,RIESGO PROFESIONAL, RIESGO EXTRAORDINARIO)" &&
                    items.item.id_tipo_permiso == 90
                  ? "OTROS"
                  : "OTROS"
              }}
            </td>
            <td
              v-if="
                items.item.id_tipo_permiso == 8 ||
                  items.item.id_tipo_permiso == 24 ||
                  (items.item.id_tipo_permiso >= 37 &&
                    items.item.id_tipo_permiso <= 43) ||
                  items.item.id_tipo_permiso == 87 ||
                  items.item.id_tipo_permiso == 104 ||
                  items.item.id_tipo_permiso == 103 ||
                  items.item.id_tipo_permiso == 88 ||
                  items.item.id_tipo_permiso == 89 ||
                  items.item.id_tipo_permiso == 94 ||
                  items.item.id_tipo_permiso == 96 ||
                  items.item.id_tipo_permiso == 98 ||
                  items.item.id_tipo_permiso == 99 ||
                  items.item.id_tipo_permiso == 100 ||
                  items.item.id_tipo_permiso == 101 ||
                  items.item.id_tipo_permiso == 102 ||
                  items.item.id_tipo_permiso == 5
              "
            >
              {{ $moment(items.item.hora_desde, "HH:mm:ss").format("HH:mm") }}
            </td>
            <td
              v-if="
                [90, 18, 95, 44, 6, 61, 14, 105, 12].includes(
                  parseInt(items.item.id_tipo_permiso)
                )
              "
            >
              {{ "" }}
            </td>
            <td
              v-if="
                items.item.id_tipo_permiso == 8 ||
                  items.item.id_tipo_permiso == 24 ||
                  (items.item.id_tipo_permiso >= 37 &&
                    items.item.id_tipo_permiso <= 43) ||
                  items.item.id_tipo_permiso == 87 ||
                  items.item.id_tipo_permiso == 104 ||
                  items.item.id_tipo_permiso == 88 ||
                  items.item.id_tipo_permiso == 89 ||
                  items.item.id_tipo_permiso == 94 ||
                  items.item.id_tipo_permiso == 96 ||
                  items.item.id_tipo_permiso == 98 ||
                  items.item.id_tipo_permiso == 99 ||
                  items.item.id_tipo_permiso == 100 ||
                  items.item.id_tipo_permiso == 102 ||
                  items.item.id_tipo_permiso == 101 ||
                  items.item.id_tipo_permiso == 103 ||
                  items.item.id_tipo_permiso == 5
              "
            >
              {{ $moment(items.item.hora_hasta, "HH:mm:ss").format("HH:mm") }}
            </td>
            <td
              v-if="
                [90, 18, 95, 44, 6, 61, 14, 105 , 12].includes(
                  parseInt(items.item.id_tipo_permiso)
                )
              "
            >
              {{ "" }}
            </td>
            <td>
              {{ items.item.nro_dias }}
            </td>
            <td>
              <!--
              {{
                items.item.jefe &&
                (items.item.permiso.id_estado == 6 ||
                  items.item.permiso.id_estado == 21) &&
                (items.item.id_tipo_permiso == 24 ||
                  items.item.id_tipo_permiso == 14 ||
                  items.item.id_tipo_permiso == 105 ||
                  items.item.id_tipo_permiso == 94 ||
                  items.item.id_tipo_permiso == 87 ||
                  items.item.id_tipo_permiso == 104 ||
                  items.item.id_tipo_permiso == 88 ||
                  items.item.id_tipo_permiso == 102 ||
                  items.item.id_tipo_permiso == 103
                )
                  ? items.item.jefe
                  : (items.item.id_tipo_permiso == 90 ||
                      items.item.id_tipo_permiso == 18 ||
                      items.item.id_tipo_permiso == 95 ||
                      items.item.id_tipo_permiso == 8 ||
                      items.item.id_tipo_permiso == 96 ||
                      items.item.id_tipo_permiso == 89 ||
                      items.item.id_tipo_permiso == 100 ||
                      items.item.id_tipo_permiso == 98 ||
                      items.item.id_tipo_permiso == 61 ||
                      items.item.id_tipo_permiso == 12 ||
                      items.item.id_tipo_permiso == 6 ||
                      items.item.id_tipo_permiso == 101 ||
                      items.item.id_tipo_permiso == 99 ||
                      (items.item.id_tipo_permiso >= 37 &&
                        items.item.id_tipo_permiso <= 43)) &&
                    items.item.permiso.id_estado == 6
                  ? "RECURSOS HUMANOS"
                  : ""
              }}
              -->
              {{ obtenerNombreDestinatario(items.item) }}
            </td>
            <td>
              {{
                items.item.rechazo
                  ? items.item.rechazo
                  : items.item.justificacion
                  ? items.item.justificacion
                  : ""
              }}
            </td>
            <td>
              {{
                items.item.permiso.id_estado == 7 &&
                (items.item.permiso.id_tipo_permiso == 8 ||
                  items.item.permiso.id_tipo_permiso == 98 ||
                  items.item.permiso.id_tipo_permiso == 99 ||
                  items.item.permiso.id_tipo_permiso == 100 ||
                  items.item.permiso.id_tipo_permiso == 101 ||
                  items.item.permiso.id_tipo_permiso == 89 ||
                  items.item.permiso.id_tipo_permiso == 96 ||
                  items.item.permiso.id_tipo_permiso == 95)
                  ? "Aprobado"
                  : items.item.estado_permiso
              }}
            </td>
            <td v-if="$route.params.id == undefined">
              {{ items.item.entregado == true ? "ENTREGADO" : "NO ENTREGADO" }}
            </td>
            <td v-if="$route.params.id !== undefined">
              <v-tooltip bottom>
                <v-checkbox
                  slot="activator"
                  v-model="items.item.entregado"
                  primary
                  :model-value="true"
                  hide-details
                  @change="documentoEntregado(items.item)"
                ></v-checkbox>
                <span>{{ items.item.entregado ? "Desmarcar" : "Marcar" }}</span>
              </v-tooltip>
            </td>
            <td class="contenedor-botones">
              <v-btn
                color="info"
                @click.prevent="verPermiso(items.item)"
                icon
                title="Ver permiso"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                v-if="
                  (items.item.permiso.id_tipo_permiso != 95 &&
                    
                    //items.item.permiso.id_tipo_permiso != 98 &&
                    //items.item.permiso.id_tipo_permiso != 99 &&
                    items.item.permiso.id_tipo_permiso != 100 &&
                    items.item.permiso.id_tipo_permiso != 101 &&
                    //// WC
                    //items.item.permiso.id_tipo_permiso != 103 &&
                    //items.item.permiso.id_tipo_permiso != 90 &&
                    //items.item.permiso.id_tipo_permiso != 18 &&
                    ///
                    items.item.permiso.id_tipo_permiso != 8 &&
                    (items.item.permiso.id_estado == 7 ||
                      items.item.permiso.id_estado == 6 ||
                      items.item.permiso.id_estado == 21 ||
                      items.item.permiso.id_estado == 77 ||
                      items.item.permiso.id_estado == 75)) ||
                    (items.item.permiso.id_tipo_permiso == 89 &&
                      (items.item.permiso.id_estado == 22 ||
                        items.item.permiso.id_estado == 77 ||
                        items.item.permiso.id_estado == 6))
                "
                color="#F58736"
                @click.prevent="verReporte(items.item)"
                icon
                title="Ver reporte"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>

              <!-- SI QUIERO QUE ESTA OPCION SOLO SE VEA EN LA BANDEJA DEL FUNCIONARIO -->

              <!-- v-if="$route.params.id===undefined && items.item.estado_permiso === 'Creado' && items.item.permiso.id_tipo_permiso ==96" -->
              <v-btn
                color="warning"
                v-if="
                  items.item.permiso.id_estado == 22 &&
                    items.item.permiso.id_tipo_permiso == 96
                "
                @click.prevent="
                  modificarPermisoToleranciaCompensacion(items.item)
                "
                icon
                title="Modificar permiso"
              >
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn
                color="warning"
                v-if="
                  items.item.permiso.id_estado == 22 &&
                    (items.item.permiso.id_tipo_permiso == 90 ||
                      items.item.permiso.id_tipo_permiso == 44)
                "
                @click.prevent="modificarPermiso(items.item)"
                icon
                title="Modificar"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                color="warning"
                v-if="
                  items.item.permiso.id_estado == 22 &&
                    
                    (items.item.permiso.id_tipo_permiso != 24 &&
                    items.item.permiso.id_tipo_permiso != 96 &&
                    items.item.permiso.id_tipo_permiso != 90 &&
                    items.item.permiso.id_tipo_permiso != 44 ) 
                    //|| ($route.params.id == undefined && items.item.permiso.id_tipo_permiso !== 105)
                    
              
                "
                @click.prevent="modificarPermiso(items.item)"
                icon
                title="Modificar"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                color="warning"
                v-if="
                  items.item.permiso.id_estado == 22 &&
                    items.item.permiso.id_tipo_permiso == 24
                "
                @click.prevent="editarPermisoCargoVacacion(items.item)"
                icon
                title="Modificar"
              >
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn
                color="red"
                v-if="
                  (items.item.permiso.id_estado == 22 &&
                    items.item.permiso.id_tipo_permiso == 96 &&
                    !$route.params.id) ||
                    (items.item.permiso.id_estado != 9 &&
                      items.item.permiso.id_tipo_permiso == 96 &&
                      $route.params.id)
                "
                @click.prevent="anularPermiso(items.item)"
                icon
                dark
                title="Anular"
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <v-btn
                color="red"
                v-if="
                  (items.item.permiso.id_estado == 22 &&
                    (items.item.permiso.id_tipo_permiso == 90 ||
                      items.item.permiso.id_tipo_permiso == 44) &&
                    !$route.params.id) ||
                    (items.item.permiso.id_estado != 9 &&
                      (items.item.permiso.id_tipo_permiso == 90 ||
                        items.item.permiso.id_tipo_permiso == 44) &&
                      $route.params.id)
                "
                @click.prevent="anularPermiso(items.item)"
                icon
                dark
                title="Anular"
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <!-- Boton anular p89 -->
              <v-btn
                color="red"
                v-if="
                  (items.item.permiso.id_estado == 22 &&
                    items.item.permiso.id_tipo_permiso != 96 &&
                    items.item.permiso.id_tipo_permiso != 90 &&
                    items.item.permiso.id_tipo_permiso != 44 &&
                    !$route.params.id) ||
                    (items.item.permiso.id_estado != 9 &&
                      items.item.permiso.id_tipo_permiso != 96 &&
                      items.item.permiso.id_tipo_permiso != 90 &&
                      items.item.permiso.id_tipo_permiso != 44 &&
                      $route.params.id)
                "
                @click.prevent="anularPermiso(items.item)"
                icon
                dark
                title="Anular"
              >
                <v-icon>delete</v-icon>
              </v-btn>

              <!-- <v-btn
                slot="activator"
                  color="blue"
                  dark
                v-if="items.item.permiso.id_estado ==22"
                @click.prevent="compensarPermisoParticular(items.item)"
                icon
                title="Adicionar compensación " 
              >
                <v-icon>refresh</v-icon>
                
              </v-btn>  -->

              <!-- <v-btn
                slot="activator"
                  color="blue"
                  dark
                v-if="(items.item.permiso.id_tipo_permiso == 96) && items.item.permiso.id_estado ==22 && items.item.compensa_tolerancia==1"
                @click.prevent="compensarPermisoTolerancia(items.item)"
                icon
                title="Adicionar compensación"
              >
                <v-icon>refresh</v-icon>
 
              </v-btn> -->
              <!--ver documentos-->
              <v-btn
                icon
                color="info"
                v-if="items.item.permiso.ruta_archivo"
                @click.native="verDocumento(items.item.permiso)"
                title="Ver documento"
              >
                <v-icon>attach_file</v-icon>
              </v-btn>
              <!--REchazar cualquier permiso -->
              <v-btn
                v-if="$route.params.id !== undefined"
                color="#E61C5B"
                dark
                @click.prevent="rechazarPermisoRRHH(items.item)"
                icon
                title="Rechazar permiso"
              >
                <v-icon>close</v-icon>
              </v-btn>

   <!-- 
              <v-btn 
               v-if="$route.params.id !== undefined"
                color="#E61C5B"
                dark
                @click.prevent="reenviarPermiso(items.item)"
                icon
                title="Reenviar permiso"
              >
                <v-icon>close</v-icon>
              </v-btn>
-->
              <v-btn 
              v-if="
                    (items.item.permiso.id_estado == 6) &&
                      $route.params.id !== undefined
                  "
                color="#E61C5B"
                dark
                @click.prevent="reenviarPermiso(items.item)"
                icon
                title="Reenviar permiso"
              >
                <v-icon>mail</v-icon>
              </v-btn>

              <!--  funcion enviar :permiso oficial por horas,licencia por duelo 6, licencia por paternidad=61 ,permiso oficial por hrs=87 -->
              <!--PERMISOS TOLERANCIA: id desde 37-43-->
              <!--PERMISOS papeleta de solcitud con cargoa vacacion24-->
            
 <!-- Botón Enviar Jefe -->
 <v-btn
    color="success"
    v-if="mostrarBotonEnviarJefe(items.item)"
    @click.prevent="enviarPermisoFuncionarioJefe(items.item)"
    icon
    title="Enviar IS"
  >
    <v-icon>send</v-icon>
  </v-btn>

  <!-- Botón Enviar General -->
  <v-btn
    color="success"
    v-if="mostrarBotonEnviarGeneral(items.item)"
    @click.prevent="enviarPermiso(items.item)"
    icon
    title="Enviar G"
  >
    <v-icon>send</v-icon>
  </v-btn>

  <!-- Botón Enviar RRHH -->
  <v-btn
    color="success"
    v-if="mostrarBotonEnviarRRHH(items.item)"
    @click.prevent="enviarPermisoRRHH(items.item)"
    icon
    title="Enviar RRHH"
  >
    <v-icon>send</v-icon>
  </v-btn>

  <!-- Botón Enviar Servidor Público -->
  <v-btn
    color="success"
    v-if="mostrarBotonServidorPublico(items.item)"
    @click.prevent="enviarPermiso(items.item)"
    icon
    title="Enviar SP"
  >
    <v-icon>send</v-icon>
  </v-btn>

              
             
              <!-- ---------SUPER APROBACION------ -->
              <v-tooltip bottom>
                <v-btn
                  v-if="
                    (items.item.permiso.id_estado == 22 ||
                      items.item.permiso.id_estado == 21 ||
                      items.item.permiso.id_estado == 6) &&
                      $route.params.id !== undefined
                  "
                  color="warning"
                  icon
                  slot="activator"
                  @click.prevent="aprobarRRHHSinPermisos(items.item)"
                >
                  <v-icon>done_all</v-icon>
                </v-btn>

                <span>Aprobar super usuario</span>
              </v-tooltip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
    <!-- ---------CALENDARIO------ -->
    <v-spacer><br /></v-spacer>
    <v-tooltip bottom>
      <v-btn
        color="green"
        slot="activator"
        dark
        @click="
          () => {
            bandera_calendario
              ? (bandera_calendario = false)
              : (bandera_calendario = true);
          }
        "
      >
        <v-icon>event_note</v-icon
        >{{ bandera_calendario ? "Ocultar calendario" : "Mostrar calendario" }}
      </v-btn>
      <span>Mostrar calendario</span>
    </v-tooltip>

    <v-card v-show="bandera_calendario">
      <h1 class="primary--text">Calendario</h1>
      <v-layout>
        <v-flex>
          <v-sheet height="500">
            <v-calendar
              ref="calendar"
              v-model="start"
              type="month"
              :end="end"
              :value="today"
              color="primary"
              locale="es"
            >
              <template v-slot:day="{ date }">
                <v-card v-for="event in eventsMap[date]" :key="event.id">
                  <v-menu v-model="event.open" full-width offset-x>
                    <template v-slot:activator="{ on }">
                      <div
                        v-if="!event.time"
                        :class="
                          event.estado == 7
                            ? 'permiso-aprobado'
                            : 'permiso-rechazado'
                        "
                        v-on="on"
                        v-html="event.title"
                      ></div>
                    </template>
                    <v-card color="grey lighten-4" min-width="350px" flat>
                      <v-toolbar color="primary" dark>
                        <v-btn icon>
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <v-toolbar-title>
                          <div v-html="event.title"></div>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                      </v-toolbar>
                      <v-card-title primary-title>
                        <span v-html="event.details"></span>
                      </v-card-title>
                      <v-card-actions>
                        <v-btn flat color="blue"> Cerrar </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-card>
              </template>
            </v-calendar>
          </v-sheet>
          <v-btn @click="$refs.calendar.prev()">
            <v-icon dark left> keyboard_arrow_left </v-icon>
            Anterior
          </v-btn>
          <v-btn @click="$refs.calendar.next()">
            Siguiente
            <v-icon right dark> keyboard_arrow_right </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue";
import crud from "@/common/util/crud-table/mixins/crud-table";
import AddSolicitud from "./dialogs/AddSolicitud";
import EnviarPermiso from "./dialogs/EnviarPermiso";
import EnviarPermisoRRHH from "./dialogs/EnviarPermisoRRHH";
import EnviarPermisoFuncionarioJefe from "./dialogs/EnviarPermisoFuncionarioJefe";
import VerPermiso from "./dialogs/VerPermiso";
import VerReporte from "./dialogs/VerReporte";
import verSeguimiento from "./dialogs/VerSeguimiento";
import AnularPermiso from "./dialogs/AnularPermiso";
import AprobarPermiso from "./dialogs/AprobarPermiso";
import AprobarPermisoRRHH from "./dialogs/AprobarPermisoRRHH";
import RechazarPermisoRRHH from "./dialogs/RechazarPermisoRRHH";
import ModificarPermiso from "./dialogs/ModificarPermiso";
import ModificarPermisoCompensacion from "./dialogs/ModificarPermisoCompensacion";
import EditarPermisoCargoVacacion from "./dialogs/EditarPermisoCargoVacacion.vue";

import VerSeguimiento from "./dialogs/VerSeguimiento.vue";
import CompensarPermiso from "./dialogs/CompensarPermiso .vue";
import CompensarPermisoParticular from "./dialogs/CompensarPermisoParticular.vue";
import CompensarPermisoTolerancia from "./dialogs/CompensarPermisoTolerancia.vue";
import VerDocumento from "./dialogs/VerDocumento.vue";
import AprobarRRHHSinPermisos from "./dialogs/AprobarRRHHSinPermisos";
import ModificarPermisoToleranciaCompensacion from "./dialogs/ModificarPermisoToleranciaCompensacion.vue";
import ReenviarPermiso from "./dialogs/ReenviarPermiso.vue";

export default {
  mixins: [crud],
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [4, 32]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      if (this.$route.params.id != null) {
        // await this.logoutUser()
        this.$router.push("/accion-no-permitida");
      }
    }

    await this.obtenerListaGestiones();
    this.periodo_seleccionado = new Date().getFullYear();
    this.$bus.$on("closeDialogVerReportePermiso", () => {});
    this.$bus.$on("closeDialogAddpermiso", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogAprobarRRHHPermiso", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogAprobarRRHHSinRestriccion", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogEnviarPermiso", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogEnviarFuncionarioJefe", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogEnviarParaRRHH", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogModificarPermiso", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogAnularRRHH", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogModificarPermisoRRHH", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogModificarPermisoCompensacion", () => {
      this.updateList();
    });
    this.$bus.$on("", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogRechazarPermisosRRHH", () => {
      this.updateList();
    });
    ///// 
    this.$bus.$on("closeDialogReenviarPermiso", () => {
      this.updateList();
    });

    this.onFilter();
    this.getRolRecursosHumanos();
    this.getNombre();
    await this.cargarFechas();
  },
  data() {
    return {
      id_usuario: this.$route.params.id,
      horas_a_compensar: 0,
      graphql: true, // Definiendo el CRUD con Graphql
      url: "vPermisosPorFuncionarios",
      esUsuario: this.$route.params.id == null,
      nombres: "",
      parametro: "",
      rol: [],
      periodo_seleccionado: new Date().getFullYear(),
      lista_gestiones: [],
      rol2: [],
      rol3: [],
      total_horas_acomuladas: 0,


      ////BOTONES
      // Configuración centralizada de tipos de permisos
      tiposPermiso: {
        // Tipos para botón Jefe
        //jefe: [14, 24, 87, 88, 102, 103, 104, 105],
        jefe: [14, 24, 87, 88, 102, 103, 104, 105,61, 6, 12, 96, 89, 94],
        // Tipos excluidos para botón General 1
        excluirGeneral1: [24, 94, 90, 88, 95, 8, 61, 12, 6, 8, 103],
         // Tipos excluidos para botón General 2
        excluirGeneral2: [12, 6, 61, 15, 8, 95, 14, 105, 24, 88, 94, 87, 104, 96, 90,89, 103],
        // Tipos para botón RRHH (antes era rango 37-43, ahora es lista)
        //rrhh: [96, 61, 12, 6, 37, 38, 39, 40, 41, 42, 43],
        rrhh: [ 37, 38, 39, 40, 41, 42, 43, 8],
        // Tipos para botón Servidor Público
        servidorPublico: [ 98, 99, 100, 5, 101]
      },

      
        


      titulo_permiso: this.$route.params.id
        ? "Gestión "
        : "Listado de solicitudes ",
      headers: [
        { text: "Nro", value: "numero", sortable: false },
        { text: "Fecha solicitud", value: "fecha_emision", sortable: false },
        { text: "Fecha salida", value: "fecha_desde", sortable: false },
        { text: "Fecha fin", value: "fecha_retorno", sortable: false },
        { text: "Nombre del permiso", value: "tipo_permiso", sortable: false },
        { text: "Horas", value: "horas_permiso", sortable: false },
        { text: "Tipo", value: "motivo", sortable: false },
        { text: "De horas", value: "", sortable: false },
        { text: "A horas", value: "", sortable: false },
        { text: "Días", value: "nro_dias", sortable: false },
        { text: "Solicitud enviada a", value: "jefe", sortable: false },
        { text: "Justificación", value: "rechazo", sortable: false },
        { text: "Estado", value: "estado_permiso", sortable: false },
        { text: "Entregado", value: "entregado", sortable: false },
        { text: this.$t("common.actions"), sortable: false }
      ],
      dataGraphql: `
        id_parametro_permiso
        id_permiso
        id_persona
        nombres
        numero
        fecha_desde
        fecha_emision
        tipo_permiso
        fecha_retorno
        estado_permiso
        nro_dias
        hora_desde
        hora_hasta
        id_lugar
        lugar_atencion
        fecha_nac_muerte
        hora_nac_muerte
        tipo_nac_muerte
        rango_horario
        rechazo
        jefe
        horas_permiso
        id_tipo_permiso
        motivo
        justificacion
        compensa_tolerancia
        id_permiso_omision
        marcado_omision
        entregado
        gestion
        permiso{
          id
          motivo
          id_tipo_permiso
           ruta_archivo
          tipo_permiso{
            id
            id_parametro_elaborado
          }
        fecha_permiso
        numero
        fecha_registro
        id_estado
        lugar

          estado{
            descripcion
          }


        }
      `,
      filters: [
        {
          field: "numero",
          label: "Numero",
          type: "number",
          typeG: "String"
        },
        {
          field: "fecha_emision",
          label: "Fecha solicitud",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_desde",
          label: "Fecha salida",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_retorno",
          label: "Fecha retorno",
          type: "text",
          typeG: "String"
        },
        {
          field: "tipo_permiso",
          label: "Nombre del permiso",
          type: "text",
          typeG: "String"
        },
        {
          field: "horas_permiso",
          label: "Horas",
          type: "text",
          typeG: "String"
        },
        {
          field: "motivo",
          label: "Tipo",
          type: "text",
          typeG: "String"
        },
        {
          field: "nro_dias",
          label: "Dias",
          type: "text",
          typeG: "String"
        },
        {
          field: "estado_permiso",
          label: "Estado de permiso",
          type: "text",
          typeG: "String"
        }
      ],
      valid: true,
      // -----------------------CALENDARIO---------------------------
      start: this.$moment().format("YYYY-MM-DD"),
      end: this.$moment().format("YYYY-MM-DD"),
      today: this.$moment().format("YYYY-MM-DD"),
      events: [],
      bandera_calendario: false,
      sw_crud_table: true
    };
  },
  computed: {
    // convert the list of events into a map of lists keyed by date
    eventsMap() {
      const map = {};
      this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e));
      return map;
    },
    initData() {
      let data = [
        {
          state: true,
          param: "id_persona",
          value: this.getPersonaId()
        },
        {
          state: true,
          param: "gestion",
          value: this.periodo_seleccionado
        },
        {
          state: true,
          param: "lista_tipo_pormisos",
          value: '"24"'
        }
      ];

      // }
      return data;
    },

    // Helper para verificar parámetros de ruta
    sinIdParametro() {
      return this.$route.params.id === undefined;
    },
    
    // Helper para obtener rol
    rolActual() {
      return this.getRolFuncionario ? this.getRolFuncionario() : null;
    }
  },
  methods: {

////// BOTONES ENVIAR

     // Métodos base de verificación
     tieneEstadoCorrecto(item) {
      return item && item.permiso && item.permiso.id_estado == 22;
    },

    esTipoEnLista(tipo, lista) {
      if (!tipo || !lista) return false;
      return lista.includes(parseInt(tipo));
    },

    // Lógica específica para cada botón (actualizada)
    mostrarBotonEnviarRRHH(item) {
      if (!this.tieneEstadoCorrecto(item) || !this.sinIdParametro) return false;
      
      const tipo = item.permiso.id_tipo_permiso;
      return this.esTipoEnLista(tipo, this.tiposPermiso.rrhh);
    },

    mostrarBotonEnviarGeneral(item) {
      if (!this.tieneEstadoCorrecto(item) || !this.sinIdParametro) return false;
      
      const tipo = Number(item.permiso.id_tipo_permiso);
      const { excluirGeneral1, excluirGeneral2, rrhh } = this.tiposPermiso;

      // Lógica para el primer botón general
      const esTipoPermitido1 = !this.esTipoEnLista(tipo, excluirGeneral1) &&
                              !this.esTipoEnLista(tipo, rrhh) &&
                              this.rolActual != 42;
/*
      // Lógica para el segundo botón general (tipo 8)
      const esTipo8 = tipo === 8 && this.getRuta() != this.getPersonaId();
*/
      // Lógica para el tercer botón general (tipo 94)
     // const esTipo94 = tipo === 94;

      // Lógica para el cuarto botón general (exclusiones específicas)
      const esTipoPermitido2 = !this.esTipoEnLista(tipo, excluirGeneral2) &&
                              !this.esTipoEnLista(tipo, rrhh);

      return esTipoPermitido1 ||  esTipoPermitido2;
    },

    // Lógica específica para cada botón
    mostrarBotonEnviarJefe(item) {
      if (!this.tieneEstadoCorrecto(item) || !this.sinIdParametro) return false;
      
      const tipo = item.permiso.id_tipo_permiso;
      return this.esTipoEnLista(tipo, this.tiposPermiso.jefe);
    },

   
////// NOMBRE DESTINATARIO
    obtenerNombreDestinatario(item) {
    if (!this.esItemValido(item)) return '';
    
    // Caso 1: Mostrar jefe
    if (item.jefe && this.mostrarJefeDestinatario(item)) {
      return item.jefe;
    }
    
    // Caso 2: Mostrar RRHH
    if (this.mostrarRrhhDestinatario(item)) {
      return "RECURSOS HUMANOS";
    }
    
    return '';
  },

  esItemValido(item) {
    return item && item.permiso && item.permiso.id_estado !== undefined && item.id_tipo_permiso !== undefined;
  },

  mostrarJefeDestinatario(item) {
    const estado = this.obtenerEstado(item);
    const tipo = this.obtenerTipo(item);
    
    if (estado === null || tipo === null) return false;
    
    const estadosPermitidos = [6, 21];
    const tiposPermitidos = [24, 14, 105, 94, 87, 104, 88, 102,61,6,12, 96, 89, 103];
    
    return estadosPermitidos.includes(estado) && 
           tiposPermitidos.includes(tipo);
  },

  mostrarRrhhDestinatario(item) {
    const estado = this.obtenerEstado(item);
    const tipo = this.obtenerTipo(item);
    
    if (estado === null || tipo === null) return false;
    
    const estadosPermitidos = [6];
    const tiposPermitidos = [
      90, 18, 95, 8,   100, 98,    101, 99,
      37, 38, 39, 40, 41, 42, 43 ,8
    ];
    
    return estadosPermitidos.includes(estado) && 
           tiposPermitidos.includes(tipo);
  },

  obtenerEstado(item) {
    try {
      return parseInt(item.permiso.id_estado);
    } catch (error) {
      return null;
    }
  },

  obtenerTipo(item) {
    try {
      return parseInt(item.id_tipo_permiso);
    } catch (error) {
      return null;
    }
  },
    
///////////////////////////////
    mostrarBotonServidorPublico(item) {
      if (!this.tieneEstadoCorrecto(item) || !this.sinIdParametro) return false;
      
      const tipo = item.permiso.id_tipo_permiso;
      return this.esTipoEnLista(tipo, this.tiposPermiso.servidorPublico) &&
             this.rolActual == 42;
    },


    async logoutUser() {
      // Obtener el token de autenticación del usuario
      const token = localStorage.getItem("token");
      console.log("token", token);
      // Enviar una solicitud al servidor para eliminar el token de autenticación
      fetch("/logout", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          // Eliminar el token de autenticación del navegador
          localStorage.removeItem("token");

          // Redirigir al usuario a la página de inicio de sesión
          window.location.href = "/login";
        })
        .catch(error => {
          console.error(error);
        });
    },
    // Metodo para actualizar el crud table con una gestion
    async actualizaCrudTable() {
      if (!this.periodo_seleccionado) {
        return;
      }
      this.sw_crud_table = false;
      await new Promise(resolve => setTimeout(resolve, 100));
      this.updateList();
      this.sw_crud_table = true;
    },
    open(event) {
      alert(event.title);
    },
    //documento entregado
    async documentoEntregado(dato) {
      try {
        let estado_entregado = "N";
        let mensaje = "¿Desea marcar como No Entregado?";
        if (dato.entregado == true) {
          estado_entregado = "S";
          mensaje = "¿Desea marcar como entregado?";
        }
        let user = this.$storage.get("user");
        this.$confirm(
          mensaje,
          async () => {
            let respuesta = await this.$service.graphql({
              query: `
          query{ 
                  runQuery(consulta:"select control.fn_papeleta_permiso_entregado(${dato.id_permiso},${user.id},'${estado_entregado}')"){
                  respuesta
                  }
                }	

              `
            });

            let resp =
              respuesta.runQuery.respuesta[0].fn_papeleta_permiso_entregado;
            if (resp.split("|"[0]) == "1") {
              this.updateList();
            }
          },
          () => {
            dato.entregado = dato.entregado ? false : true;
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    //metodo para obtener las gestiones:
    async obtenerListaGestiones() {
      try {
        let id_persona = this.$route.params.id
          ? parseInt(this.$route.params.id)
          : this.$storage.get("user").id_persona;

        this.lista_gestiones = [];
        let resp = await this.$service.graphql({
          query: `
            query{
                  runQuery(consulta:"select distinct extract (year from pd.fecha_desde)as periodo from control.permiso p join control.permiso_detalle pd on pd.id_permiso = p.id where p.id_persona = ${parseInt(
                    id_persona
                  )} union select extract (year from now())as periodo"){
                  respuesta
                  }
                }	
          `
        });

        if (resp.runQuery.respuesta.length > 0) {
          this.lista_gestiones = resp.runQuery.respuesta;
        } else {
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtieneFeriadosPersona() {
      try {
        let res = await this.$service.graphql({
          query: `query{
            vFeriadoFuncionarios(id_persona:${this.getPersonaId()}){
              rows{
                id_persona
                nro_item
                fecha
                nacional
              }
            }
          }
					`
        });
        res = res.vFeriadoFuncionarios.rows;
        return res;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarFechas() {
      try {
        let res = await this.$service.graphql({
          query: `query{
            vPermisosPorFuncionarios(id_persona: ${this.getPersonaId()}){
              rows{
                id_permiso
                id_persona
                nombres
                numero
                fecha_desde
                fecha_emision
                tipo_permiso
                fecha_retorno
                estado_permiso
                nro_dias
                hora_desde
                hora_hasta
                id_lugar
                lugar_atencion
                fecha_nac_muerte
                hora_nac_muerte
                tipo_nac_muerte
                rango_horario
                rechazo
                horas_permiso
                id_tipo_permiso
                compensa_tolerancia
                permiso{
                  id
                  motivo
                  id_tipo_permiso
                  ruta_archivo
                  tipo_permiso{
                    id
                    id_parametro_elaborado
                  }
                fecha_permiso
                numero
                fecha_registro
                id_estado
                lugar
                  estado{
                    descripcion
                  }
                }
                
              }
            }
          }
					`
        });
        res = res.vPermisosPorFuncionarios.rows;
        let feriados = await this.obtieneFeriadosPersona();
        let lista_fechas = [];
        for (let i = 0; i < res.length; i++) {
          const element = res[i];
          // Obtneniendo el rango de fechas en results
          var diasEntreFechas = function(desde, hasta) {
            var dia_actual = desde;
            var fechas = [];
            while (dia_actual.isSameOrBefore(hasta)) {
              fechas.push(dia_actual.format("YYYY-MM-DD"));
              dia_actual.add(1, "days");
            }
            return fechas;
          };
          let desde = null;
          let hasta = null;
          if (element.fecha_desde) {
            desde = this.$moment(
              element.fecha_desde
                .split("/")
                .reverse()
                .join("-")
            );
          }
          if (element.fecha_retorno) {
            hasta = this.$moment(
              element.fecha_retorno
                .split("/")
                .reverse()
                .join("-")
            );
          }
          let results;
          if (element.fecha_desde && element.fecha_retorno) {
            results = diasEntreFechas(desde, hasta);
            //Recorriendo las fechas para ir creando los eventos
            for (let index = 0; index < results.length; index++) {
              const fecha = results[index];
              // Validamos fines de semana
              var feha = new Date(fecha);
              var dayOfWeek = feha.getDay();
              if (dayOfWeek !== 5 && dayOfWeek !== 6) {
                const found = feriados.find(element => element.fecha == fecha);
                if (!found) {
                  let evento = {
                    id: element.id_permiso,
                    title: element.tipo_permiso,
                    details: `${element.tipo_permiso}<br><strong>Estado: </strong>${element.estado_permiso}`,
                    date: fecha,
                    open: false,
                    estado: element.permiso.id_estado
                  };
                  lista_fechas.push(evento);
                }
              }
            }
          }
        }
        this.events = lista_fechas;
      } catch (error) {
        console.log(error);
      }
    },

    async aprobarRRHHSinPermisos(item) {
      this.$bus.$emit("openDialogAprobarRRHHSinPermisos", item);
    },
    verReporte(item) {
      console.log('item', item);
      this.$bus.$emit("openDialogVerReportePermiso", item);
    },
    getRolRecursosHumanos() {
      let user = this.$storage.get("user");
      let roles = user.roles;
      let rol = null;

      roles.forEach(element => {
        if (element.id == 4 || element.id == 32) {
          rol = 4;
        }
      });

      return rol;
    },
    getRolFuncionario() {
      let user = this.$storage.get("user");
      let roles = user.roles;
      let rol = null;

      roles.forEach(element => {
        if (element.id == 42 || element.id == 32) {
          rol = 42;
        }
      });

      return rol;
    },
    getRolFuncionario() {
      let user = this.$storage.get("user");
      let roles = user.roles;
      let rol = null;

      roles.forEach(element => {
        if (element.id == 42 || element.id == 32) {
          rol = element = 42;
        }
      });

      return rol;
    },
    async validaHorasCompensacion(id_permiso, hora_desde, hora_hasta) {
      try {
        let respuesta;
        let valida;
        let hora_limite = this.$moment(hora_hasta, "hh:mm")
          .subtract(hora_desde, "hh:mm")
          .format("hh:mm");

          console.log(`
              query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${id_permiso})"){
                    respuesta
                }
              }
            `);


        respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${id_permiso})"){
                    respuesta
                  }
                }

              `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null
        ) {
          return false;
        } else {
          valida = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;

          if (hora_limite + ":00" == valida) {
            return true;
          } else {
            let respuesta2 = await this.$service.graphql({
              query: `
                                query{
                                runQuery(consulta:"select control.fn_mayor_dos_horas('${hora_limite}','${valida}')"){
                                    respuesta
                                }
                                }

                            `
            });
            let resp2 = respuesta2.runQuery.respuesta[0].fn_mayor_dos_horas;
            if (resp2 === "verdad") {
              return true;
            } else {
              return false;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async validaHoras(id_persona, fecha, hora_desde, hora_hasta) {
      //abre el btn de compensacion
  
      try {
        // agregado por Wagner coarite
        // Validar y formatear la fecha
         let fechaFormateada;
        
        if (fecha instanceof Date) {
            fechaFormateada = fecha.toISOString().split('T')[0];
        } else if (typeof fecha === 'string') {
            // Si es string, verificar si ya está en formato YYYY-MM-DD
            if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
                fechaFormateada = fecha;
            } else {
                // Parsear desde otros formatos (ej: DD/MM/YYYY)
                const [day, month, year] = fecha.split(/[/-]/);
                fechaFormateada = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            }
        } else {
            throw new Error("Formato de fecha no soportado");
        }

        console.log(`
              query{
                runQuery(consulta:"select control.fn_corresponde_compensacion(${id_persona},'${fechaFormateada}','${hora_desde}','${hora_hasta}')"){
                                    respuesta
                }
              }
            `);

        let respuesta = await this.$service.graphql({
          query: `
                                query{
                                runQuery(consulta:"select control.fn_corresponde_compensacion(${id_persona},'${fechaFormateada}','${hora_desde}','${hora_hasta}')"){
                                    respuesta
                                }
                                }

                            `
        });
        let resp = respuesta.runQuery.respuesta[0].fn_corresponde_compensacion;

        if (resp == "SI") {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async horas_compensar(id) {
      this.horas_a_compensar = id;
      return this.horas_a_compensar;
    },
    getPersonaId() {
      const user = this.$storage.get("user");

      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    getRuta() {
      let p = this.$route.path;
      const a = p.split("/");

      return a[3];
    },

    getPersonaId() {
      const user = this.$storage.get("user");
      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    async enviarPermisoFuncionarioJefe(item) {
      if (item.id_tipo_permiso == 88) {
        const valida = await this.validaHoras(
          item.id_persona,
          item.fecha_retorno,
          item.hora_desde,
          item.hora_hasta
        );
        let res = await this.validaHorasCompensacion(
          item.id_permiso,
          item.hora_desde,
          item.hora_hasta
        );
        if ((res == true && valida == true) || valida == false) {
          this.$bus.$emit("openDialogEnviarPermisoFuncionarioJefe", item);
        } else {
          this.$confirm("Le falta compensar horas por el permiso", () => {});
        }
      } else {
        this.$bus.$emit("openDialogEnviarPermisoFuncionarioJefe", item); //una funcion que me diga si pud
      }
      // this.$bus.$emit("openDialogEnviarPermisoFuncionarioJefe", item);
    },
    async enviarPermiso(item) {

      if (item.id_tipo_permiso == 88) {
        const valida = await this.validaHoras(
          item.id_persona,
          item.fecha_retorno,
          item.hora_desde,
          item.hora_hasta
        );
        let res = await this.validaHorasCompensacion(
          item.id_permiso,
          item.hora_desde,
          item.hora_hasta
        );

        console.log('valida...',valida);
        console.log('res...',res);
        if ((res == true && valida == true) || valida == false) {
          this.$bus.$emit("openDialogEnviarPermiso", item);
        } else {
          this.$confirm("Le falta compensar mas horas", () => {});
        }
      } else {
        this.$bus.$emit("openDialogEnviarPermiso", item); //una funcion que me diga si pud
      }

      //this.$bus.$emit("openDialogEnviarPermiso", item);
    },
    enviarPermisoRRHH(item) {
      this.$bus.$emit("openDialogEnviarPermisoRRHH", item);
    },
    aprobarPermiso(item) {
      this.$bus.$emit("openDialogAprobarPermiso", item);
    },
    aprobarPermisoRRHH(item) {
      this.$bus.$emit("openDialogAprobarPermisoRRHH", item);
    },
    rechazarPermisoRRHH(item) {
      this.$bus.$emit("openDialogRechazarPermisoRRHH", item);
    },

    ////// WC
    reenviarPermiso(item) {
      this.$bus.$emit("openDialogReenviarPermiso", item);
      
    },

    verPermiso(item) {
      this.$bus.$emit("openDialogVerPermiso", item);
    },
    anularPermiso(item) {
      this.$bus.$emit("openDialogAnularPermiso", item);
    },

    async getNombre() {
      try {
        let res = await this.$service.graphql({
          query: `query{
            personas(id: ${this.getPersonaId()}){
              rows{
                id
                ap_paterno
              ap_materno
                nombres
                ap_casada
              }
            }
          }
					`
        });

        let persona = res.personas.rows[0];
        this.nombres =
          (persona.ap_paterno ? persona.ap_paterno : "") +
          " " +
          (persona.ap_materno ? persona.ap_materno : "") +
          " " +
          persona.nombres;

        let user = this.$storage.get("user");
        this.rol = user.roles[0].id;
        for (let i = 0; i < user.roles.length; i++) {
          const element = user.roles[i];
          if (element.id == 42 || element.id == 32) {
            this.rol2 = 42;
          } else {
            this.rol2 = 0;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerSubpermiso(descripcion) {
      try {
        /*  let res = await this.$service.graphql({
            query: `

              query{
                tipoSubpermisos(id_permiso:${parseInt(this.permiso.id_tipo_permiso)}){
                  rows{
                    id
                    id_estado
                    id_permiso
                    descripcion
                  }
                }
              }
          `,
          });
          this.tipo_subpermisos = res.tipoSubpermisos.rows;*/
        let tipo_subpermisos = [
          { id: 1, descripcion: "Cáncer infantil o adolescente" },
          {
            id: 3,
            descripcion:
              "Enfermedades neurológicas que requieren de tratamiento quirúrgico"
          },
          {
            id: 2,
            descripcion: "Enfermedades sistémicas que requieren trasplante"
          },
          { id: 4, descripcion: "Insuficiencia renal crónica" },
          {
            id: 5,
            descripcion:
              "Enfermedades osteoarticulares (huesos y articulaciones) que requieren tratamiento quirúrgico y rehabilitación"
          },
          { id: 6, descripcion: "Discapacidad grave y muy grave" },
          {
            id: 7,
            descripcion:
              "Accidente grave con riesgo de muerte o secuela funcional severa y permanente"
          },
          { id: 8, descripcion: "Accidente grave" }
        ];
        let id_subpermi = tipo_subpermisos.find(
          fruta => fruta.descripcion == descripcion
        ).id;
        return id_subpermi;
      } catch (error) {
        console.log(error);
      }
    },
    async modificarPermisoToleranciaCompensacion(item) {
      item.rol = 42;
      if (this.getRolRecursosHumanos() == 4) {
        item.rol = 4;
      }
      this.$bus.$emit("openDialogModificarPermisoToleranciaCompensacion", item);
    },
    async modificarPermiso(item) {
      item.compensa = "si";
      if (item.id_tipo_permiso == 44) {
        let id_subpermiso = await this.obtenerSubpermiso(item.permiso.motivo);

        item.id_tipo_subpermiso = id_subpermiso;
      } else {
        item.id_tipo_subpermiso = 0;
      }
      if (item.id_tipo_permiso != 88) {
        if (this.esUsuario) {
          item.rol = 42;
        } else {
          item.rol = 4;
        }
        this.$bus.$emit("openDialogModificarPermiso", item);
      } else {
        if (this.esUsuario) {
          item.rol = 42;
          item.es_funcionario = true;
        } else {
          item.rol = 4;
          item.es_funcionario = false;
        }
        this.$bus.$emit("openDialogModificarPermisoCompensacion", item);
      }
      this.updateList();
    },
    editarPermisoCargoVacacion(item) {
      if (this.esUsuario) {
        item.rol = 42;
        item.es_funcionario = true;
      } else {
        item.rol = 4;
        item.es_funcionario = false;
      }
      this.$bus.$emit("openDialogEditarPermisoCargoVacacion", item);
    },
    compensarPermiso(item) {
      this.$bus.$emit("openDialogCompensarPermiso", item);
    },
    async compensarPermisoParticular(item1) {
      const valida = await this.validaHoras(
        item1.id_persona,
        item1.fecha_retorno,
        item1.hora_desde,
        item1.hora_hasta
      );
      if (valida) {
        //la funcion validaHoras que me devuelva el total de las hrs solicitadas para permiso nro0 88 y me diga si es mayor a 2 hrs
        this.$bus.$emit("openDialogCompensarPermisoParticular", item1);
      } else {
        this.$confirm("No tiene horas a compensar", () => {});
      }
    },
    async compensarPermisoTolerancia(item1) {
      this.$bus.$emit("openDialogCompensarPermisoTolerancia", item1);
    },
    verSeguimiento(item) {
      this.$bus.$emit("openDialogVerSeguimiento", item);
    },
    async verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    }
  },
  components: {
    CrudTable,
    AddSolicitud,
    EnviarPermiso,
    EnviarPermisoRRHH,
    VerPermiso,
    AnularPermiso,
    AprobarPermiso,
    AprobarPermisoRRHH,
    RechazarPermisoRRHH,
    ReenviarPermiso,
    ModificarPermiso,
    EditarPermisoCargoVacacion,
    CompensarPermiso,

    verSeguimiento,
    VerSeguimiento,
    CompensarPermisoParticular,
    VerDocumento,
    EnviarPermisoFuncionarioJefe,
    CompensarPermisoTolerancia,
    VerReporte,
    AprobarRRHHSinPermisos,
    ModificarPermisoCompensacion,
    ModificarPermisoToleranciaCompensacion
  }
};
</script>

<style lang="scss" scoped>
.permiso-aprobado {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #3bc429dc;
  color: #ffffff;
  border: 1px solid #5f9c26;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
.permiso-rechazado {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #f76e2f;
  color: #ffffff;
  border: 1px solid #f13800;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
.contenedor-botones {
  .v-btn {
    margin: 1px 0px;
  }
}
.tabla-permisos {
  td {
    font-size: 0.95rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/Permiso.vue